import React, { Component } from "react";

import settings from "../settings.js";

import Crown from "../assets/crown.svg";
import Clock from "../assets/clock.svg";
import Scrollbars from "react-custom-scrollbars";
import dayjs from "dayjs";
import First from "../assets/first.svg";
import Second from "../assets/second.svg";
import Third from "../assets/third.svg";

const Competitor = (data, place, maxQuantity) => {
  const placement = (() => {
    switch (place) {
      case 0:
        return "first";
      case 1:
        return "second";
      case 2:
        return "third";
      default:
        return "rest";
    }
  })();
  const widthPercentage = (data.total / maxQuantity) * 100;
  return (
    <div className={"competitor"} key={data.CustomerName}>
      {(() => {
        switch (place) {
          case 0:
            return (
              <div className="">
                <div className="competitorPlace">
                  <img src={First} alt="1" />
                </div>
              </div>
            );
          case 1:
            return (
              <div className="">
                <div className="competitorPlace">
                  <img src={Second} alt="2" />
                </div>
              </div>
            );
          case 2:
            return (
              <div className="">
                <div className="competitorPlace">
                  <img src={Third} alt="3" />
                </div>
              </div>
            );
          default:
            return (
              <div className="">
                <div className="competitorPlace">
                  <div className={`placement ${placement}`}>{place + 1}</div>
                </div>
              </div>
            );
        }
      })()}

      <div className="competitorName">{data.customerName}</div>

      <div className="competitorNumbers">
        <div className="competitorTotal">
          <div
            className={`competitorProgress ${placement}`}
            style={{ width: `${widthPercentage}%` }}></div>
        </div>
      </div>
      {data.total && (
        <div className="competitorQuantity">
          {parseFloat(data.total).toString().replace(".", ",")}
        </div>
      )}
    </div>
  );
};

class Competition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      data: [],
      title: "Competitie",
      startDate: "",
      endDate: "",
      competitorStatus: "",
    };
  }

  componentDidMount() {
    this.loadData();
    // Add interval to refresh data every minute
    this.interval = setInterval(() => {
      this.loadData();
    }, 60000); // 60000 ms = 1 minute
  }

  componentWillUnmount() {
    // Clean up the interval when component unmounts
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  loadData() {
    this.setState({ isLoading: true });
    fetch(
      settings.server_url +
        "get_monthly_competition/" +
        window.sessionStorage.getItem("sid")
    )
      .then((res) => res.json())
      .then((response) => {
        if (response.result) {
          this.setState({
            data: response.data,
            isLoading: false,
            title: response.title,
            description: response.description,
            startDate: response.startDate,
            endDate: response.endDate,
            competitorStatus: "Er zijn momenteel geen deelnemers",
          });
        } else {
          this.setState({
            isLoading: false,
            title: "Geen competitie",
            description: "Geen competitie",
            competitorStatus: "Er zijn momenteel geen competities",
            startDate: "",
            endDate: "",
          });
        }
      })
      .catch((error) => console.error("Error:", error));
  }

  render() {
    const maxQuantity =
      this.state.data && this.state.data.length > 0
        ? Math.max(...this.state.data.map((item) => item.total))
        : 1;
    return (
      <div className="gridItem grid">
        <div className="gridHeader">
          {/*
          <div className="gridHeaderIcon">
            <img src={Crown} alt="" />
          </div>
          */}
          <div className="gridHeaderTitle">
            {this.state.title ? this.state.title : "Competitie"}
          </div>
          {this.state.endDate && (
            <div className="gridHeaderTimer">
              {this.state.endDate === "" ? (
                "Er zijn momenteel geen competities"
              ) : dayjs(this.state.endDate, "DD-MM-YYYY").diff(
                  dayjs(),
                  "days"
                ) < 0 ? (
                "Competitie beëindigd"
              ) : (
                <>
                  <img src={Clock} alt="" style={{ width: 16 }} /> Nog{" "}
                  {isNaN(
                    dayjs(this.state.endDate, "DD-MM-YYYY").diff(
                      dayjs(),
                      "days"
                    )
                  )
                    ? 0
                    : dayjs(this.state.endDate, "DD-MM-YYYY").diff(
                        dayjs(),
                        "days"
                      )}{" "}
                  dagen
                </>
              )}
            </div>
          )}
        </div>
        {this.state.isLoading ? (
          <Scrollbars style={{ height: 272 }}>
            <div className="gridRows loading"></div>
          </Scrollbars>
        ) : this.state.data.length > 0 ? (
          <Scrollbars style={{ height: 205 }}>
            <div className="gridRows">
              {this.state.data.map((row, index) =>
                Competitor(row, index, maxQuantity)
              )}
            </div>
          </Scrollbars>
        ) : (
          <Scrollbars style={{ height: 205 }}>
            <div className="gridRows">
              <div className={"THT"}>
                <div>
                  <div className="THTTitle">{this.state.competitorStatus}</div>
                </div>
              </div>
            </div>
          </Scrollbars>
        )}
        <div className="gridFooter">
          <div className="gridFooterText">{this.state.description}</div>
        </div>
      </div>
    );
  }
}

export default Competition;
